import React__default from 'react';
import { EditorStack } from './EditorStack.js';

const EditorRows = ({ children }) => {
  return /* @__PURE__ */ React__default.createElement(EditorStack, { gap: 0.5, direction: "column" }, children);
};

export { EditorRows };
//# sourceMappingURL=EditorRows.js.map
